import { VipRatingDetails, VipUserRating } from 'src/types/VIP';
import { client } from 'src/utils/api';

export const getVipRating = () =>
  client.get<VipUserRating>('/rating-service/v1/user-ratings/codes/VIP');

export const getVipRatingDetails = () =>
  client.get<VipRatingDetails>('/rating-service/v1/details/codes/VIP');
